<template>
	<div class="cs_inquiry card">
		<h3 class="title">{{ $t('merchant.menu_2.menu2') }}</h3>
		<form v-if="isWrite" class="q_write" autocomplete="off" @submit.prevent>
			<div class="select_wrap w100 mb_10">
				<select class="contact_type" v-model="type_seq">
					<option value="" selected disabled>
						{{ $t('cs.placeholder.type') }}
					</option>
					<option
						v-for="item in ticket_type_list"
						:key="item.seq"
						:value="item.seq"
					>
						{{ item.title }}
					</option>
				</select>
			</div>
			<input
				type="text"
				:placeholder="$t('cs.placeholder.title')"
				class="mb_10"
				v-model="title"
			/>
			<textarea
				class="ask"
				:placeholder="$t('cs.placeholder.content')"
				v-model="content"
			></textarea>
			<div class="inquiry_button_area">
				<button class="button_primary">{{ $t('button.cancel') }}</button>
				<button class="button_bg_blue" @click="registTicket">
					{{ $t('button.confirm') }}
				</button>
			</div>
		</form>
		<div v-else class="inquiry_complete">
			<div class="complete_box">
				<div class="status_icon success"></div>
				<p class="mb_10">
					{{ $t('merchant.inquiry.text11') }}<br />
					<span class="">{{ $t('merchant.inquiry.text12') }}</span>
					{{ $t('merchant.inquiry.text13') }}
				</p>
				<button class="button_bg_blue mt_20" @click="goList">
					{{ $t('button.inquiry_list') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { createTicket, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'Inquiry',
	data() {
		return {
			isWrite: true,
			parent_seq: 0,
			type_seq: '',
			title: '',
			content: '',
			email_address: '',
			password: '',
			field_values: [],
			ticket_type_list: [],
			ticket_id: '',
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadTicketTypeList();
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticket_type_list = data;
		},
		async registTicket() {
			const params = {
				parent_seq: this.parent_seq,
				type_seq: this.type_seq,
				title: this.title,
				content: this.content,
				email_address: this.email_address,
				password: this.password,
				field_values: this.field_values,
			};
			await createTicket(params)
				.then(result => {
					this.ticket_id = result.ticket_id;
					this.isWrite = false;
				})
				.catch(commonError);
		},
		goList() {
			this.$router.push({ name: 'merchant-console-cs-inquiry-list' });
		},
	},
};
</script>
